import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_AdvisorConsoleProxy = {
    vv1: {
        sendLogs: { method: HttpMethod.POST, path: '/v1/log' }
    }
};
//# sourceMappingURL=api-def.js.map